// Fehlertext für den Dialog: Lehnt Close eine Angabe ab, steht der Grund verschachtelt in `field-errors`
// (z. B. { note: { "field-errors": { str: "Input should be a valid string" } } }). Die allgemeine Anzeige kennt nur eine
// Ebene; hier wird alles aufgelöst und mit dem deutschen Feldnamen versehen.
import { ApiFehler } from "../api";
import { fehlerInfo } from "../components/Fehler";

const FELDER: Record<string, string> = {
  value: "Betrag",
  value_period: "Zahlung",
  note: "Notiz",
  date_won: "Abschlussdatum",
  confidence: "Konfidenz",
  status_id: "Status",
  user_id: "Zuständig",
  contact_id: "Kontakt",
  lead_id: "Lead",
};

function sammeln(wert: unknown, feld: string, aus: string[]): void {
  if (typeof wert === "string") {
    aus.push(feld ? `${FELDER[feld] ?? feld}: ${wert}` : wert);
  } else if (wert && typeof wert === "object") {
    const o = wert as Record<string, unknown>;
    const fehler = o["field-errors"];
    if (fehler && typeof fehler === "object") {
      for (const [k, v] of Object.entries(fehler as Record<string, unknown>)) sammeln(v, feld || k, aus);
    }
    const allgemein = o.errors;
    if (Array.isArray(allgemein)) for (const t of allgemein) sammeln(t, feld, aus);
    if (!fehler && !Array.isArray(allgemein)) {
      for (const [k, v] of Object.entries(o)) sammeln(v, feld || k, aus);
    }
  }
}

export function oppFehlerText(e: unknown): string {
  if (e instanceof ApiFehler && e.code === "close_fehler") {
    const antwort = e.details?.close_antwort;
    const teile: string[] = [];
    sammeln(antwort, "", teile);
    const eindeutig = [...new Set(teile)];
    if (eindeutig.length) return `Close hat die Änderung abgelehnt: ${eindeutig.join("; ")}`;
  }
  return fehlerInfo(e).text;
}
